"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultBlocks = exports.defaultPhases = exports.leiKingWan = exports.southHorizonsPhase = exports.southHorizons = void 0;
exports.southHorizons = [
    {
        id: 80,
        buildingId: 3048,
        name: 'Albany Court (Tower 32)',
        url: '/en/building/albany-court-tower-32/3048',
        active: false,
        parentPhaseId: 32,
        location: {
            lat: 22.243607,
            lng: 114.149281,
        },
    },
    {
        id: 81,
        buildingId: 3048,
        name: 'Berkeley Court (Tower 33)',
        url: '/en/building/berkeley-court-tower-33/3048',
        active: false,
        parentPhaseId: 32,
        location: {
            lat: 22.243287,
            lng: 114.149192,
        },
    },
    {
        id: 82,
        buildingId: 3048,
        name: 'Cambridge Court (Tower 33A)',
        url: '/en/building/cambridge-court-tower-33a/3048',
        active: false,
        parentPhaseId: 32,
        location: {
            lat: 22.242944,
            lng: 114.149107,
        },
    },
    {
        id: 83,
        buildingId: 3048,
        name: 'Dover Court (Tower 25)',
        url: '/en/building/dover-court-tower-25/3048',
        active: false,
        parentPhaseId: 32,
        location: {
            lat: 22.242477,
            lng: 114.149412,
        },
    },
    {
        id: 84,
        buildingId: 3048,
        name: 'Eaton Court (Tower 26)',
        url: '/en/building/eaton-court-tower-26/3048',
        active: false,
        parentPhaseId: 32,
        location: {
            lat: 22.242694,
            lng: 114.149741,
        },
    },
    {
        id: 85,
        buildingId: 3048,
        name: 'Fenton Court (Tower 27)',
        url: '/en/building/fenton-court-tower-27/3048',
        active: false,
        parentPhaseId: 32,
        location: {
            lat: 22.242922,
            lng: 114.150079,
        },
    },
    {
        id: 86,
        buildingId: 3048,
        name: 'Fung King Court (Tower 29)',
        url: '/en/building/fung-king-court-tower-29/3048',
        active: false,
        parentPhaseId: 32,
        location: {
            lat: 22.243823,
            lng: 114.150115,
        },
    },
    {
        id: 87,
        buildingId: 3048,
        name: 'Grosvenor Court (Tower 28)',
        url: '/en/building/grosvenor-court-tower-28/3048',
        active: false,
        parentPhaseId: 32,
        location: {
            lat: 22.24315,
            lng: 114.150393,
        },
    },
    {
        id: 88,
        buildingId: 3048,
        name: 'Hoi Fai Court (Tower 2)',
        url: '/en/building/hoi-fai-court-tower-2/3048',
        active: false,
        parentPhaseId: 29,
        location: {
            lat: 22.244678,
            lng: 114.147905,
        },
    },
    {
        id: 89,
        buildingId: 3048,
        name: 'Hoi Ngar Court (Tower 3)',
        url: '/en/building/hoi-ngar-court-tower-3/3048',
        active: false,
        parentPhaseId: 29,
        location: {
            lat: 22.244732,
            lng: 114.147348,
        },
    },
    {
        id: 90,
        buildingId: 3048,
        name: 'Hoi Ning Court (Tower 5)',
        url: '/en/building/hoi-ning-court-tower-5/3048',
        active: false,
        parentPhaseId: 29,
        location: {
            lat: 22.24474,
            lng: 114.146626,
        },
    },
    {
        id: 91,
        buildingId: 3048,
        name: 'Hoi Sing Court (Tower 1)',
        url: '/en/building/hoi-sing-court-tower-1/3048',
        active: false,
        parentPhaseId: 29,
        location: {
            lat: 22.245065,
            lng: 114.147926,
        },
    },
    {
        id: 92,
        buildingId: 3048,
        name: 'Hoi Wan Court (Tower 4)',
        url: '/en/building/hoi-wan-court-tower-4/3048',
        active: false,
        parentPhaseId: 29,
        location: {
            lat: 22.24473,
            lng: 114.146962,
        },
    },
    {
        id: 93,
        buildingId: 3048,
        name: 'Hoi Yat Court (Tower 6)',
        url: '/en/building/hoi-yat-court-tower-6/3048',
        active: false,
        parentPhaseId: 29,
        location: {
            lat: 22.244736,
            lng: 114.146276,
        },
    },
    {
        id: 94,
        buildingId: 3048,
        name: 'Mei Cheung Court (Tower 20)',
        url: '/en/building/mei-cheung-court-tower-20/3048',
        active: false,
        parentPhaseId: 31,
        location: {
            lat: 22.242642,
            lng: 114.148642,
        },
    },
    {
        id: 95,
        buildingId: 3048,
        name: 'Mei Chun Court (Tower 21)',
        url: '/en/building/mei-chun-court-tower-21/3048',
        active: false,
        parentPhaseId: 31,
        location: {
            lat: 22.242043,
            lng: 114.14778,
        },
    },
    {
        id: 96,
        buildingId: 3048,
        name: 'Mei Fai Court (Tower 17)',
        url: '/en/building/mei-fai-court-tower-17/3048',
        active: false,
        parentPhaseId: 31,
        location: {
            lat: 22.242793,
            lng: 114.147526,
        },
    },
    {
        id: 97,
        buildingId: 3048,
        name: 'Mei Hay Court (Tower 18)',
        url: '/en/building/mei-hay-court-tower-18/3048',
        active: false,
        parentPhaseId: 31,
        location: {
            lat: 22.242803,
            lng: 114.147919,
        },
    },
    {
        id: 98,
        buildingId: 3048,
        name: 'Mei Hin Court (Tower 23)',
        url: '/en/building/mei-hin-court-tower-23/3048',
        active: false,
        parentPhaseId: 31,
        location: {
            lat: 22.242038,
            lng: 114.148606,
        },
    },
    {
        id: 99,
        buildingId: 3048,
        name: 'Mei Hong Court (Tower 19)',
        url: '/en/building/mei-hong-court-tower-19/3048',
        active: false,
        parentPhaseId: 31,
        location: {
            lat: 22.242709,
            lng: 114.148245,
        },
    },
    {
        id: 100,
        buildingId: 3048,
        name: 'Mei Ka Court (Tower 23A)',
        url: '/en/building/mei-ka-court-tower-23a/3048',
        active: false,
        parentPhaseId: 31,
        location: {
            lat: 22.24217,
            lng: 114.148995,
        },
    },
    {
        id: 101,
        buildingId: 3048,
        name: 'Mei Wah Court (Tower 22)',
        url: '/en/building/mei-wah-court-tower-22/3048',
        active: false,
        parentPhaseId: 31,
        location: {
            lat: 22.241987,
            lng: 114.148175,
        },
    },
    {
        id: 102,
        buildingId: 3048,
        name: 'Pak King Court (Tower 31)',
        url: '/en/building/pak-king-court-tower-31/3048',
        active: false,
        parentPhaseId: 32,
        location: {
            lat: 22.243965,
            lng: 114.149359,
        },
    },
    {
        id: 103,
        buildingId: 3048,
        name: 'Wai King Court (Tower 30)',
        url: '/en/building/wai-king-court-tower-30/3048',
        active: false,
        parentPhaseId: 32,
        location: {
            lat: 22.24389,
            lng: 114.149728,
        },
    },
    {
        id: 104,
        buildingId: 3048,
        name: 'Yee Fai Court (Tower 13A)',
        url: '/en/building/yee-fai-court-tower-13a/3048',
        active: false,
        parentPhaseId: 30,
        location: {
            lat: 22.243269,
            lng: 114.145748,
        },
    },
    {
        id: 105,
        buildingId: 3048,
        name: 'Yee Fung Court (Tower 11)',
        url: '/en/building/yee-fung-court-tower-11/3048',
        active: false,
        parentPhaseId: 30,
        location: {
            lat: 22.244384,
            lng: 114.145843,
        },
    },
    {
        id: 106,
        buildingId: 3048,
        name: 'Yee King Court (Tower 8)',
        url: '/en/building/yee-king-court-tower-8/3048',
        active: false,
        parentPhaseId: 30,
        location: {
            lat: 22.244401,
            lng: 114.145023,
        },
    },
    {
        id: 107,
        buildingId: 3048,
        name: 'Yee Lai Court (Tower 10)',
        url: '/en/building/yee-lai-court-tower-10/3048',
        active: false,
        parentPhaseId: 30,
        location: {
            lat: 22.243808,
            lng: 114.14446,
        },
    },
    {
        id: 108,
        buildingId: 3048,
        name: 'Yee Lok Court (Tower 13)',
        url: '/en/building/yee-lok-court-tower-13/3048',
        active: false,
        parentPhaseId: 30,
        location: {
            lat: 22.243663,
            lng: 114.145681,
        },
    },
    {
        id: 109,
        buildingId: 3048,
        name: 'Yee Mei Court (Tower 7)',
        url: '/en/building/yee-mei-court-tower-7/3048',
        active: false,
        parentPhaseId: 30,
        location: {
            lat: 22.244663,
            lng: 114.145351,
        },
    },
    {
        id: 110,
        buildingId: 3048,
        name: 'Yee Moon Court (Tower 12)',
        url: '/en/building/yee-moon-court-tower-12/3048',
        active: false,
        parentPhaseId: 30,
        location: {
            lat: 22.244011,
            lng: 114.145719,
        },
    },
    {
        id: 111,
        buildingId: 3048,
        name: 'Yee Ngar Court (Tower 9)',
        url: '/en/building/yee-ngar-court-tower-9/3048',
        active: false,
        parentPhaseId: 30,
        location: {
            lat: 22.244077,
            lng: 114.144757,
        },
    },
    {
        id: 112,
        buildingId: 3048,
        name: 'Yee Tsui Court (Tower 16)',
        url: '/en/building/yee-tsui-court-tower-16/3048',
        active: false,
        parentPhaseId: 30,
        location: {
            lat: 22.243,
            lng: 114.146609,
        },
    },
    {
        id: 113,
        buildingId: 3048,
        name: 'Yee Wan Court (Tower 15)',
        url: '/en/building/yee-wan-court-tower-15/3048',
        active: false,
        parentPhaseId: 30,
        location: {
            lat: 22.243165,
            lng: 114.146134,
        },
    },
    {
        id: 999998,
        buildingId: 3048,
        name: 'House 1',
        url: '/en/building/yee-wan-court-tower-15/3048',
        active: false,
        parentPhaseId: 30,
        location: {
            lat: 22.2435711,
            lng: 114.147164
        },
        isPropertyId: true,
    },
    {
        id: 999999,
        buildingId: 3048,
        name: 'House 2',
        url: '/en/building/yee-wan-court-tower-15/3048',
        active: false,
        parentPhaseId: 30,
        location: {
            lat: 22.2435711,
            lng: 114.147164
        },
    },
];
exports.southHorizonsPhase = [
    {
        id: 29,
        name: 'Phase 1',
        url: '/en/phase/south-horizons-phase-1/29',
        completionYear: 1992,
        blockCount: 4,
        unitCount: 120,
        floorRange: [
            '35',
            '40',
        ],
        active: false,
        mapActive: false,
    },
    {
        id: 30,
        name: 'Phase 2',
        url: '/en/phase/south-horizons-phase-2/30',
        completionYear: 1993,
        blockCount: 4,
        unitCount: 120,
        floorRange: [
            '33',
            '42',
        ],
        active: false,
        mapActive: false,
    },
    {
        id: 31,
        name: 'Phase 3',
        url: '/en/phase/south-horizons-phase-3/31',
        completionYear: 1994,
        blockCount: 4,
        unitCount: 120,
        floorRange: [
            '36',
            '40',
        ],
        active: false,
        mapActive: false,
    },
    {
        id: 32,
        name: 'The Oasis',
        url: '/en/phase/south-horizons-the-oasis/32',
        completionYear: 1995,
        blockCount: 4,
        unitCount: 120,
        floorRange: [
            '30',
            '35',
        ],
        active: false,
        mapActive: false,
    },
];
exports.leiKingWan = [
    {
        id: 280,
        buildingId: 280,
        name: 'Hong Fook Court',
        url: '/en/building/hong-fook-court/280',
        active: false,
        parentPhaseId: -1,
        location: {
            lat: 22.2900795,
            lng: 114.2044757,
        },
    },
    {
        id: 285,
        buildingId: 285,
        name: 'Hung Fook Court',
        url: '/en/building/hung-fook-court/285',
        active: false,
        parentPhaseId: -1,
        location: {
            lat: 22.290105,
            lng: 114.204542,
        },
    },
    {
        id: 283,
        buildingId: 283,
        name: 'Ka Fook Court',
        url: '/en/building/ka-fook-court/283',
        active: false,
        parentPhaseId: -1,
        location: {
            lat: 22.2891718,
            lng: 114.2041506,
        },
    },
    {
        id: 277,
        buildingId: 277,
        name: 'King Fook Court',
        url: '/en/building/king-fook-court/277',
        active: false,
        parentPhaseId: -1,
        location: {
            lat: 22.2903919,
            lng: 114.2044292,
        },
    },
    {
        id: 275,
        buildingId: 275,
        name: 'On Fook Court',
        url: '/en/building/on-fook-court/275',
        active: false,
        parentPhaseId: -1,
        location: {
            lat: 22.289581,
            lng: 114.204743,
        },
    },
    {
        id: 278,
        buildingId: 278,
        name: 'Pak Cheung Court',
        url: '/en/building/pak-cheung-court/278',
        active: false,
        parentPhaseId: -1,
        location: {
            lat: 22.289791,
            lng: 114.204289,
        },
    },
    {
        id: 284,
        buildingId: 284,
        name: 'Pak Hee Court',
        url: '/en/building/pak-hee-court/284',
        active: false,
        parentPhaseId: -1,
        location: {
            lat: 22.2894839,
            lng: 114.2043828,
        },
    },
    {
        id: 281,
        buildingId: 281,
        name: 'Pak Kai Court',
        url: '/en/building/pak-kai-court/281',
        active: false,
        parentPhaseId: -1,
        location: {
            lat: 22.2898469,
            lng: 114.2045685,
        },
    },
    {
        id: 279,
        buildingId: 279,
        name: 'Pak Lee Court',
        url: '/en/building/pak-lee-court/279',
        active: false,
        parentPhaseId: -1,
        location: {
            lat: 22.290342,
            lng: 114.204154,
        },
    },
    {
        id: 274,
        buildingId: 274,
        name: 'Pak Sing Court',
        url: '/en/building/pak-sing-court/274',
        active: false,
        parentPhaseId: -1,
        location: {
            lat: 0,
            lng: 0,
        },
    },
    {
        id: 276,
        buildingId: 276,
        name: 'Pak Tak Court',
        url: '/en/building/pak-tak-court/276',
        active: false,
        parentPhaseId: -1,
        location: {
            lat: 22.2900216,
            lng: 114.2042899,
        },
    },
    {
        id: 282,
        buildingId: 282,
        name: 'Tak Fook Court',
        url: '/en/building/tak-fook-court/282',
        active: false,
        parentPhaseId: -1,
        location: {
            lat: 22.2894406,
            lng: 114.2041041,
        },
    },
];
exports.defaultPhases = [
    {
        id: 10,
        name: 'Phase I',
        url: '#phase-1',
        mapActive: false,
        completionYear: 2002,
        floorRange: [43, 56],
        blockCount: 4,
        unitCount: 120,
    },
    {
        id: 11,
        name: 'Phase II',
        url: '#phase-2',
        mapActive: false,
        completionYear: 2003,
        floorRange: [40, 58],
        blockCount: 4,
        unitCount: 120,
    },
];
exports.defaultBlocks = [
    {
        id: 30,
        buildingId: 30,
        name: 'Block 1',
        active: false,
        url: '#block-1',
        parentPhaseId: 10,
        location: {
            lat: 22.245067,
            lng: 114.147909,
        },
    },
    {
        id: 31,
        buildingId: 31,
        name: 'Block 2',
        active: false,
        url: '#block-2',
        parentPhaseId: 10,
        location: {
            lat: 22.244664,
            lng: 114.147898,
        },
    },
    {
        id: 32,
        buildingId: 32,
        name: 'Block 3',
        active: false,
        url: '#block-3',
        parentPhaseId: 11,
        location: {
            lat: 22.244070,
            lng: 114.144758,
        },
    },
    {
        id: 33,
        buildingId: 33,
        name: 'Block 4',
        active: false,
        url: '#block-4',
        parentPhaseId: 11,
        location: {
            lat: 22.243803,
            lng: 114.144477,
        },
    },
];
